import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 31 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17.375 2.25c.413 0 .75.337.75.75v13.5c0 .413-.337.75-.75.75h-5.1a4.5 4.5 0 0 0-3.9-2.25 4.5 4.5 0 0 0-3.9 2.25h-.6a.75.75 0 0 1-.75-.75V3c0-.413.337-.75.75-.75zm1.5 17.25a4.501 4.501 0 0 0 9 0h1.875c.623 0 1.125-.502 1.125-1.125s-.502-1.125-1.125-1.125h-.375v-5.752c0-.698-.277-1.364-.769-1.856L24.233 5.27a2.62 2.62 0 0 0-1.856-.769h-2.002V3c0-1.655-1.345-3-3-3h-13.5c-1.655 0-3 1.345-3 3v13.5c0 1.655 1.345 3 3 3a4.501 4.501 0 0 0 9 0zm8.142-8.269.019.019h-6.661v-4.5h2.002a.38.38 0 0 1 .267.108zM6.125 19.5a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m17.25-2.25a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }